import { DateNormalizer } from '../date_utils/normalizer'
import { DateTime } from 'luxon'

export default class Anchor {

  /**
   * @param {string|Date|DateTime} dt - A date string, JS Date, or Luxon DateTime
   */
  constructor(dt) {
    this.date = DateNormalizer.normalize(dt)
  }

  // Returns a new DateTime shifted by the given options.
  // Supports: days, weeks, months, years, quarters
  shift(options) {
    if (!options || Object.keys(options).length === 0) return this.date;

    return new this.constructor(this.date.plus(this.#normalizeOptions(options)))
  }

  // Mutates this.date in place and returns this Anchor.
  shiftInPlace(options) {
    if (!options || Object.keys(options).length === 0) return this

    this.date = this.shift(options).date
    return this
  }

  // Returns the end of the last full month before this.date
  // Luxon endOf returns the last millisecond of the period, but nothing else
  // does and that makes it hard to compare when all we care about is the date.
  get trailingEnd() {
    return this.date.minus({ months: 1 }).endOf('month').set(this.#zeroTime)
  }

  toISODate() {
    return this.date.toISODate()
  }

  // private

  #normalizeOptions(opts) {
    return Object.entries(opts).reduce((acc, [unit, count]) => {
      if (unit === 'quarters') {
        acc.months = 3 * count
      } else {
        acc[unit] = count
      }
      return acc
    }, {})
  }

  get #zeroTime() {
    return { hour: 0, minute: 0, second: 0, millisecond: 0 }
  }
}
